<template>
  <div>
    <PageHead title="报销比例设置"></PageHead>
    <!-- 取暖费报销  暂时注释掉-->
    <!-- <div class="oa-layout-content">
      <div class="tableList">
        <p class="tableListTitle">取暖费报销</p>
        <a-table
          :pagination="false"
          :columns="columns"
          :data-source="dataList.reimbursementTypeList1"
          rowKey="key"
          :loading="loading"
        >
          <div slot="proportion" slot-scope="text, record">
            <a-button
              @click="openUpdateModel('取暖费报销', 'proportion', text, record)"
            >
              {{ record.proportion }}%
            </a-button>
          </div>
          <div slot="startFee" slot-scope="text, record">
            <a-button
              @click="openUpdateModel('取暖费报销', 'startFee', text, record)"
            >
              {{ record.startFee }}
            </a-button>
          </div>
          <div slot="onlineFee" slot-scope="text, record">
            <a-button
              @click="openUpdateModel('取暖费报销', 'onlineFee', text, record)"
            >
              {{ record.onlineFee }}
            </a-button>
          </div>
        </a-table>
      </div>
    </div> -->
    <!-- 门诊费用报销  -->
    <div class="oa-layout-content">
      <div class="tableList">
        <p class="tableListTitle">门诊费用报销</p>
        <a-table
          :pagination="false"
          :columns="columns"
          :data-source="dataList.reimbursementTypeList3"
          rowKey="roleId"
          :loading="loading"
        >
          <div slot="proportion" slot-scope="text, record">
            <a-button
              @click="openUpdateModel('取暖费报销', 'proportion', text, record)"
            >
              {{ record.proportion }}%
            </a-button>
          </div>
          <div slot="startFee" slot-scope="text, record">
            <a-button
              @click="openUpdateModel('取暖费报销', 'startFee', text, record)"
            >
              {{ record.startFee }}
            </a-button>
          </div>
          <div slot="onlineFee" slot-scope="text, record">
            <a-button
              @click="openUpdateModel('取暖费报销', 'onlineFee', text, record)"
            >
              {{ record.onlineFee }}
            </a-button>
          </div>
        </a-table>
      </div>
    </div>
    <!-- 住院费用报销  -->
    <div class="oa-layout-content">
      <div class="tableList">
        <p class="tableListTitle">住院费用报销</p>
        <a-table
          :pagination="false"
          :columns="columns"
          :data-source="dataList.reimbursementTypeList2"
          rowKey="roleId"
          :loading="loading"
        >
          <div slot="proportion" slot-scope="text, record">
            <a-button
              @click="openUpdateModel('取暖费报销', 'proportion', text, record)"
            >
              {{ record.proportion }}%
            </a-button>
          </div>
          <div slot="startFee" slot-scope="text, record">
            <a-button
              @click="openUpdateModel('取暖费报销', 'startFee', text, record)"
            >
              {{ record.startFee }}
            </a-button>
          </div>
          <div slot="onlineFee" slot-scope="text, record">
            <a-button
              @click="openUpdateModel('取暖费报销', 'onlineFee', text, record)"
            >
              {{ record.onlineFee }}
            </a-button>
          </div>
        </a-table>
      </div>
    </div>

    <!-- 分页器 -->
    <!-- <div class="pagination">
        <a-pagination v-model="page" :total="total" @change="pageChange" />
      </div> -->

    <!-- 修改弹窗 -->
    <a-modal
      v-model="visible"
      :title="modelTitle"
      @ok="handleOk"
      :width="500"
      :confirm-loading="confirmLoading"
    >
      <div class="item-formCont">
        <span class="leftTitle">核算类型:</span>
        <span class="textContent">{{ modelReimbursementGroup }}</span>
      </div>
      <blank height="20"> </blank>
      <div class="item-formCont">
        <span class="leftTitle">{{ modelTypeValue }}:</span>
        <a-input class="w100 ml20" placeholder="" v-model="modelInputValue" />
      </div>

      <blank height="20"> </blank>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: '核算类型',
    dataIndex: 'reimbursementGroup',
    key: 'reimbursementGroup',
    width: 160,
    align: 'center'
    // scopedSlots: { customRender: 'index' }
  },
  {
    title: '职工类型',
    dataIndex: 'workersType',
    key: 'workersType',
    ellipsis: true,
    // align: 'left'
    align: 'center'
  },
  {
    title: '报销比例（%）',
    dataIndex: 'proportion',
    key: 'proportion',
    ellipsis: true,
    scopedSlots: { customRender: 'proportion' },
    // align: 'left'
    align: 'center'
  },

  {
    title: '起付线（元）',
    dataIndex: 'startFee',
    key: 'startFee',
    scopedSlots: { customRender: 'startFee' },
    ellipsis: true,
    // align: 'left'
    align: 'center'
  },

  {
    title: '封顶（元）',
    dataIndex: 'onlineFee',
    key: 'onlineFee',
    scopedSlots: { customRender: 'onlineFee' },
    // width: 160,
    // align: 'left'
    align: 'center'
  }
]
import { reimbursementRateList, updateReimbursementRateList } from './api/api'
export default {
  data() {
    return {
      columns,
      loading: false, // 表格加载
      confirmLoading: false, // 确认按钮加载
      dataList: [], // 表格数据

      modelTitle: '', // 弹窗标题
      modelReimbursementGroup: '', // 弹窗核算类型
      modelInputValue: '', // 弹窗输入框的值
      typeValue: null,
      modelTypeValue: '', // 点击的当前类型
      modelId: '', // 当前id
      updateParams: {},
      visible: false, // 弹窗显示

      // 分页器相关
      page: 1,
      size: 10,
      total: 0 //总条数
    }
  },
  computed: {},
  created() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      reimbursementRateList().then((res) => {
        this.loading = false
        let { data, code } = res.data
        if (code === 0) {
          this.dataList = data
        }
      })

      // params.page = this.page
      // params.size = this.size
      // getRoleList(params).then((res) => {
      //   this.loading = false
      //   if (res.data.code == 0) {
      //     this.roleList = res.data.data
      //     this.total = res.data.count
      //   }
      // })
    },

    // 唤醒弹窗
    openUpdateModel(title, typeValue, text, data) {
      this.visible = true
      this.modelTitle = title // 表格弹窗标题赋值
      this.typeValue = typeValue
      if (typeValue !== '') {
        if (typeValue === 'proportion') {
          this.modelTypeValue = '报销比例'
        } else if (typeValue === 'startFee') {
          this.modelTypeValue = '起付线'
        } else {
          this.modelTypeValue = '封顶'
        }
      }
      this.modelInputValue = text
      this.modelReimbursementGroup = data.reimbursementGroup
      this.modelId = data.id
    },
    // 确认修改
    handleOk() {
      this.confirmLoading = true
      if (this.typeValue === 'proportion') {
        this.updateParams = {
          id: this.modelId,
          proportion: this.modelInputValue
        }
      } else if (this.typeValue === 'startFee') {
        this.updateParams = {
          id: this.modelId,
          startFee: this.modelInputValue
        }
      } else {
        this.updateParams = {
          id: this.modelId,
          onlineFee: this.modelInputValue
        }
      }
      updateReimbursementRateList(this.updateParams).then((res) => {
        let { code } = res.data
        if (code === 0) {
          this.$message.success('操作成功')
          this.updateParams = {} // 清空参数
          this.confirmLoading = false
          this.visible = false
          this.load()
        }
      })
    }

    // 页码改变
    // pageChange(pageNumber) {
    //   this.page = pageNumber
    //   this.load()
    // }
  }
}
</script>

<style lang="scss" scoped>
.tableList {
  .tableListTitle {
    margin: 0;
    height: 47px;
    background-color: rgba(250, 250, 250, 1);
    // padding-left: 30px;
    text-align: center;
    line-height: 47px;
    font-size: 18px;
    font-weight: 600;
  }
}

// 弹窗
.item-formCont {
  .leftTitle {
    font-size: 18px;
    color: rgba(113, 113, 113, 1);
    font-weight: 500;
  }
  .textContent {
    font-size: 18px;
    margin-left: 20px;
    color: rgba(113, 113, 113, 1);
    font-weight: 500;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/system/reimbursementRate.vue